module.exports = __webpack_public_path__ + "img/about2.3868cc40.png";